import { render, staticRenderFns } from "./logdetails.vue?vue&type=template&id=8155aeb2&scoped=true&"
import script from "./logdetails.vue?vue&type=script&lang=js&"
export * from "./logdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8155aeb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8155aeb2')) {
      api.createRecord('8155aeb2', component.options)
    } else {
      api.reload('8155aeb2', component.options)
    }
    module.hot.accept("./logdetails.vue?vue&type=template&id=8155aeb2&scoped=true&", function () {
      api.rerender('8155aeb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/blockedLog/components/logdetails.vue"
export default component.exports